import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

export const returnLengthHandler = (value) => {
    const returnLengthContentElements = [
        ...document.querySelectorAll('.js-return-length-additional-content'),
    ];

    returnLengthContentElements.forEach((el) => {
        el.classList.add('d-none');
        toggleAllInputsInContainer(el, false);
    });

    returnLengthContentElements
        .filter((el) => el.dataset.for === value)
        .forEach((el) => {
            el.classList.remove('d-none');
            toggleAllInputsInContainer(el, true);
        });
};

export const returnLengthListener = () => {
    const returnLengthElements = document.querySelectorAll('.js-return-length');

    returnLengthElements.forEach((returnLengthElement) => {
        returnLengthElement.addEventListener('change', () => {
            console.log(returnLengthElement.value);
            returnLengthHandler(returnLengthElement.value);
        });
    });
};
